
import jwtDecode from 'jwt-decode';

function isLogin(token) {
    try {
        let decoded = jwtDecode(token)
        return (decoded.exp > (new Date().getTime() / 1000 | 0) ? true : false);
    } catch (e) {
        console.log(e)
        return false
    }
}

export default { isLogin }


// WEBPACK FOOTER //
// ./src/components/Util/Util.js